/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrainingFrequencyType } from './TrainingFrequencyType';
import {
    TrainingFrequencyTypeFromJSON,
    TrainingFrequencyTypeFromJSONTyped,
    TrainingFrequencyTypeToJSON,
    TrainingFrequencyTypeToJSONTyped,
} from './TrainingFrequencyType';
import type { TrainingPaymentMode } from './TrainingPaymentMode';
import {
    TrainingPaymentModeFromJSON,
    TrainingPaymentModeFromJSONTyped,
    TrainingPaymentModeToJSON,
    TrainingPaymentModeToJSONTyped,
} from './TrainingPaymentMode';
import type { TrainingType } from './TrainingType';
import {
    TrainingTypeFromJSON,
    TrainingTypeFromJSONTyped,
    TrainingTypeToJSON,
    TrainingTypeToJSONTyped,
} from './TrainingType';

/**
 * 
 * @export
 * @interface TrainingCreateRequest
 */
export interface TrainingCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof TrainingCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingCreateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {TrainingFrequencyType}
     * @memberof TrainingCreateRequest
     */
    frequencyType: TrainingFrequencyType;
    /**
     * 
     * @type {TrainingPaymentMode}
     * @memberof TrainingCreateRequest
     */
    paymentMode: TrainingPaymentMode;
    /**
     * 
     * @type {TrainingType}
     * @memberof TrainingCreateRequest
     */
    trainingType?: TrainingType;
    /**
     * 
     * @type {Date}
     * @memberof TrainingCreateRequest
     */
    seasonStartDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof TrainingCreateRequest
     */
    seasonEndDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingCreateRequest
     */
    frequencyPattern?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingCreateRequest
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingCreateRequest
     */
    endTime: string;
    /**
     * 
     * @type {number}
     * @memberof TrainingCreateRequest
     */
    trainingFee?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingCreateRequest
     */
    createdBy?: string | null;
}



/**
 * Check if a given object implements the TrainingCreateRequest interface.
 */
export function instanceOfTrainingCreateRequest(value: object): value is TrainingCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('frequencyType' in value) || value['frequencyType'] === undefined) return false;
    if (!('paymentMode' in value) || value['paymentMode'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function TrainingCreateRequestFromJSON(json: any): TrainingCreateRequest {
    return TrainingCreateRequestFromJSONTyped(json, false);
}

export function TrainingCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'frequencyType': TrainingFrequencyTypeFromJSON(json['frequencyType']),
        'paymentMode': TrainingPaymentModeFromJSON(json['paymentMode']),
        'trainingType': json['trainingType'] == null ? undefined : TrainingTypeFromJSON(json['trainingType']),
        'seasonStartDate': json['seasonStartDate'] == null ? undefined : (new Date(json['seasonStartDate'])),
        'seasonEndDate': json['seasonEndDate'] == null ? undefined : (new Date(json['seasonEndDate'])),
        'frequencyPattern': json['frequencyPattern'] == null ? undefined : json['frequencyPattern'],
        'startTime': json['startTime'],
        'endTime': json['endTime'],
        'trainingFee': json['trainingFee'] == null ? undefined : json['trainingFee'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
    };
}

export function TrainingCreateRequestToJSON(json: any): TrainingCreateRequest {
    return TrainingCreateRequestToJSONTyped(json, false);
}

export function TrainingCreateRequestToJSONTyped(value?: TrainingCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'frequencyType': TrainingFrequencyTypeToJSON(value['frequencyType']),
        'paymentMode': TrainingPaymentModeToJSON(value['paymentMode']),
        'trainingType': TrainingTypeToJSON(value['trainingType']),
        'seasonStartDate': value['seasonStartDate'] == null ? value['seasonStartDate'] : value['seasonStartDate'].toISOString().substring(0,10),
        'seasonEndDate': value['seasonEndDate'] == null ? value['seasonEndDate'] : value['seasonEndDate'].toISOString().substring(0,10),
        'frequencyPattern': value['frequencyPattern'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'trainingFee': value['trainingFee'],
        'createdBy': value['createdBy'],
    };
}

